import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import { DataTableComponent } from './containers/data-table/data-table.component';
import { ColumnFormatDirective } from './directives';
import { ColumnDefDirective } from './directives/column-def.directive';
import { DetailRowDirective } from './directives/detail-row.directive';
import { GroupRowDirective } from './directives/group-row.directive';
import { HeaderDefDirective } from './directives/header-def.directive';
import { ColumnHeaderPipe } from './pipe/column-header.pipe';
import { TableEmptyStateComponent } from './standalone-components/empty-state/empty-state.component';
import { DataTableLoadingComponent } from './standalone-components/loading/loading.component';

@NgModule({
  imports: [
    CommonModule,
    CdkDrag,
    CdkDropList,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatIconModule,
    MatRadioModule,
    MatSortModule,
    MatTableModule,
    TranslationCoreModule,
    MatMenuModule,
    TableEmptyStateComponent,
    DataTableLoadingComponent,
    MatBadgeModule,
    ColumnHeaderPipe,
  ],
  declarations: [
    DetailRowDirective,
    GroupRowDirective,
    ColumnDefDirective,
    ColumnFormatDirective,
    HeaderDefDirective,
    DataTableComponent,
  ],
  exports: [
    DetailRowDirective,
    GroupRowDirective,
    ColumnDefDirective,
    ColumnFormatDirective,
    HeaderDefDirective,
    DataTableComponent,
  ],
})
export class DataTableModule {}
